// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "@reach/router";
import PageHeader from "../../../components/PageHeader";
import PageTitle from "../../../components/PageTitle";
import PageBody from "../../../components/PageBody";
import NewsThemeForm from "./NewsThemeForm";
import { AuthentifiedUser } from "../../../../api/backend-openapi";
import { useStore } from "effector-react";
import { authentifiedUserStore } from "../../../../state/auth/AuthStore";
import { NboAction } from "../../../types/AuthTypes";

interface NewsThemeEditProps extends RouteComponentProps {
  newsThemeId?: string;
}

const NewsThemeScreen: React.FunctionComponent<NewsThemeEditProps> = (
  props: NewsThemeEditProps
) => {
  const { t } = useTranslation();
  const authentifiedUser: AuthentifiedUser | null = useStore(
    authentifiedUserStore
  );
  const canEdit: boolean =
    authentifiedUser?.rights.nboNewsTheme?.includes(NboAction.nboUpdate) ||
    false;
  const canDelete: boolean =
    authentifiedUser?.rights.nboNewsTheme?.includes(NboAction.nboDelete) ||
    false;
  const canValidate: boolean =
    authentifiedUser?.rights.nboNewsTheme?.includes(NboAction.nboValidate) ||
    false;

  const [editMode, setEditMode] = useState<boolean>(false);
  const { newsThemeId } = props;

  return (
    <>
      <PageHeader>
        <PageTitle
          title={t(
            editMode ? "news_theme.edit_title" : "news_theme.detail_title"
          )}
        />
      </PageHeader>
      <PageBody>
        <NewsThemeForm
          newsThemeId={newsThemeId ? newsThemeId : ""}
          editMode={editMode}
          setEditMode={setEditMode}
          canEdit={canEdit}
          canDelete={canDelete}
          canValidate={canValidate}
        />
      </PageBody>
    </>
  );
};

export default NewsThemeScreen;
